import type { SVGProps } from 'react';

const MinusCircle = (props?: SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.00006 8.00002C3.00006 5.23862 5.23862 3.00006 8.00002 3.00006C10.7614 3.00006 13 5.23862 13 8.00002C13 10.7614 10.7614 13 8.00002 13C5.23862 13 3.00006 10.7614 3.00006 8.00002Z"
      stroke="currentColor"
      strokeWidth="1.03447"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.2413 8H5.75862"
      stroke="currentColor"
      strokeWidth="1.03447"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default MinusCircle;
